export const onboardingEmptyEmbedding =
  'data:text/html;base64,PGh0bWw+CjxoZWFkPgoJPHN0eWxlPgoJYm9keSwgaHRtbCB7CgkJYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7CgkJb3ZlcmZsb3c6aGlkZGVuOwoJfQoJPC9zdHlsZT4KPC9oZWFkPgo8Ym9keT4KCQo8L2JvZHk+CjwvaHRtbD4='
